import { Card } from '@/ui/design-system/components';
import MetricHeroCard from 'components/MetricHeroCard';
import { useEntityPageContext } from './EntityContext';

/**
 * The entity's metric hero. `children` sit above it inside the same card,
 * which is where the pop-index pages put their lifecycle badge.
 */
const EntityHeroCard = ({ healthStats, children, ...rest }) => {
    const { dataSource, row, isLoading } = useEntityPageContext();

    return (
        <Card className="overflow-visible">
            {children}
            <MetricHeroCard
                source={dataSource}
                data={row}
                healthStats={healthStats}
                cluster={row?.cluster}
                isLoading={isLoading && !row}
                {...rest}
            />
        </Card>
    );
};

export default EntityHeroCard;
